import { Directive, HostListener } from '@angular/core';
import { CommonServices } from '../Common/CommonServices';

@Directive({
  selector: '[phoneNumberChecker]',
  standalone: false
})
export class PhoneNumberDirective {
  private regex: RegExp = /^[0-9+\-]+$/;

  constructor(private commonServices: CommonServices) { }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const inputChar = String.fromCharCode(event.charCode);
    if (!this.regex.test(inputChar)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Numbers and + and - only', 2);
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData?.getData('text') || '';
    if (!this.regex.test(clipboardData)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Pasted content must be numbers and + and - only', 2);
    }
  }
}
